import { render } from "./d3BarchartComparitive.vue?vue&type=template&id=2de80080&scoped=true"
import script from "./d3BarchartComparitive.vue?vue&type=script&lang=js"
export * from "./d3BarchartComparitive.vue?vue&type=script&lang=js"

import "./d3BarchartComparitive.vue?vue&type=style&index=0&id=2de80080&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de80080"]])

export default __exports__